import React from 'react';
import { Typography } from '@saviynt/design-system';

import { CF_SEC_BLD } from '../../constants';

interface FormHeaderProp {
  title: string;
  level: number;
  index: number;
  isSubsection: boolean;
}

/**
 * FormHeader
 * @param title - Title of the form section
 * @param level - Level of the form section
 * @param index - Index of the form section
 * @param isSubsection - Whether the form section is a subsection or not
 */
function FormHeader({ title, level, index, isSubsection }: FormHeaderProp) {
  if (level === 0 && index === 0) {
    return null;
  }

  return (
    <Typography kind={isSubsection ? 'h2' : 'h3'} color={CF_SEC_BLD}>
      {title}
    </Typography>
  );
}

export default FormHeader;
